<template>
  <v-dialog persistent scrollable v-model="config.status.active" max-width="600">
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat class="grey lighten-2">
          <v-toolbar-title class="blue-grey--text text--darken-4">読み込み設定</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn depressed
            color="blue-grey darken-4 grey--text text--lighten-2"
            @click.stop="reset">
            <v-icon small>fa-undo</v-icon>&nbsp;初期値に戻す
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form lazy-validation ref="form" v-model="form.valid">
            <v-row dense>
              <v-col cols="12" class="grey lighten-3">
                <v-subheader class="blue-grey--text text--darken-4">日付</v-subheader>
              </v-col>
              <v-col cols="12">
                <v-select required v-model="form.dates.sheet"
                  label="シート番号"
                  :items="getSizeItems"
                  :rules="rules.sheet"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="form.dates.due"
                  label="入金期日"
                  mask="A##"
                  :rules="rules.cell"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="form.dates.charged"
                  label="発行日"
                  mask="A##"
                  :rules="rules.cell"
                />
              </v-col>
              <v-col cols="12" class="grey lighten-3">
                <v-subheader class="blue-grey--text text--darken-4">請求金額</v-subheader>
              </v-col>
              <v-col cols="12">
                <v-select required
                  v-model="form.charges.sheet"
                  label="シート番号"
                  :items="getSizeItems"
                  :rules="rules.sheet"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="form.charges.school"
                  label="学費"
                  mask="A##"
                  :rules="rules.cell"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="form.charges.stay"
                  label="滞在費用"
                  mask="A##"
                  :rules="rules.cell"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="form.charges.flight"
                  label="航空券代金"
                  mask="A##"
                  :rules="rules.cell"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="form.charges.insurance"
                  label="保険費用"
                  mask="A##"
                  :rules="rules.cell"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="form.charges.visa"
                  label="査証費用"
                  mask="A##"
                  :rules="rules.cell"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="form.charges.support"
                  label="サポート費用"
                  mask="A##"
                  :rules="rules.cell"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="form.charges.domestic"
                  label="国内諸経費"
                  mask="A##"
                  :rules="rules.cell"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="form.charges.others"
                  label="その他"
                  mask="A##"
                  :rules="rules.cell"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn text color="secondary" @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed color="secondary" :disabled="!isValid" @click.stop="submit">設定する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const DEF = {
  DATES: {
    SHEET: 2,
    DUE: 'I28',
    CHARGED: 'M3'
  },
  CHARGES: {
    SHEET: 3,
    SCHOOL: 'P29',
    STAY: 'P37',
    FLIGHT: 'F45',
    INSURANCE: 'L45',
    VISA: 'T45',
    SUPPORT: 'F53',
    DOMESTIC: 'L53',
    OTHERS: 'T53'
  }
}
export default {
  name: 'insertModalLoaderConfig',
  data () {
    return {
      config: {
        status: {
          active: false
        }
      },
      meta: {
        sizes: new Array(100).fill(null).map((_, i) => (i + 1))
      },
      form: {
        valid: true,
        dates: {
          sheet: DEF.DATES.SHEET,
          due: DEF.DATES.DUE,
          charged: DEF.DATES.CHARGED
        },
        charges: {
          sheet: DEF.CHARGES.SHEET,
          school: DEF.CHARGES.SCHOOL,
          stay: DEF.CHARGES.STAY,
          flight: DEF.CHARGES.FLIGHT,
          insurance: DEF.CHARGES.INSURANCE,
          visa: DEF.CHARGES.VISA,
          support: DEF.CHARGES.SUPPORT,
          domestic: DEF.CHARGES.DOMESTIC,
          others: DEF.CHARGES.OTHERS
        }
      },
      rules: {
        sheet: [ v => !!v || '必須項目です' ],
        cell: [
          v => !!v || '必須項目です',
          v => !!(v.length !== 1) || 'セルの値が無効です'
        ]
      }
    }
  },
  methods: {
    open: function () {
      this.$set(this.config.status, 'active', true)
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$emit('done', this.form)
        this.close()
      }
    },
    reset: function () {
      this.$set(this, 'form', {
        valid: true,
        dates: {
          sheet: DEF.DATES.SHEET,
          due: DEF.DATES.DUE,
          charged: DEF.DATES.CHARGED
        },
        charges: {
          sheet: DEF.CHARGES.SHEET,
          school: DEF.CHARGES.SCHOOL,
          stay: DEF.CHARGES.STAY,
          flight: DEF.CHARGES.FLIGHT,
          insurance: DEF.CHARGES.INSURANCE,
          visa: DEF.CHARGES.VISA,
          support: DEF.CHARGES.SUPPORT,
          domestic: DEF.CHARGES.DOMESTIC,
          others: DEF.CHARGES.OTHERS
        }
      })
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    getSizeItems () {
      return this.meta.sizes
    }
  }
}
</script>
